/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  EntityId,
  List,
  OrganizationTeam,
  OrganizationTeamTitle,
} from "./data-contracts";

/**
 * No description
 * @tags teams
 * @name ListTeamsInOrganizationById
 * @summary List all teams
 * @request GET:/orgs/{organizationId}/teams
 * @secure
 */

// @ts-ignore
export const listTeamsInOrganizationById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /** The unique identifier of a member of the organization. Only teams they can manage will be returned. */
    owner?: string;
    /** If provided, only teams whose name contains the given parameter will be returned. Case insensitive. */
    title?: string;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: OrganizationTeam[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/teams",
  method: "get",
  streaming: false,
  tags: ["teams"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags teams
 * @name CreateOrganizationTeam
 * @summary Create a team
 * @request PUT:/orgs/{organizationId}/teams
 * @secure
 */

// @ts-ignore
export const createOrganizationTeam: {
  route: string;
  method: "put";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {};
  RequestBody: {
    /** Title of the team */
    title: OrganizationTeamTitle;
    /** A list of organization member identifiers */
    members?: string[];
  };
  RequestHeaders: {};
  ResponseBody: OrganizationTeam;
  ResponseStatusCode: 201;
} = {
  route: "/orgs/{organizationId}/teams",
  method: "put",
  streaming: false,
  tags: ["teams"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags teams
 * @name GetTeamInOrganizationById
 * @summary Get a team
 * @request GET:/orgs/{organizationId}/teams/{teamId}
 * @secure
 */

// @ts-ignore
export const getTeamInOrganizationById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique ID of the Team */
    teamId: EntityId;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: OrganizationTeam;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/teams/{teamId}",
  method: "get",
  streaming: false,
  tags: ["teams"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags teams
 * @name UpdateTeamInOrganizationById
 * @summary Update a team
 * @request PATCH:/orgs/{organizationId}/teams/{teamId}
 * @secure
 */

// @ts-ignore
export const updateTeamInOrganizationById: {
  route: string;
  method: "patch";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique ID of the Team */
    teamId: EntityId;
  };
  RequestQuery: {};
  RequestBody: {
    /** Title of the team */
    title: OrganizationTeamTitle;
  };
  RequestHeaders: {};
  ResponseBody: OrganizationTeam;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/teams/{teamId}",
  method: "patch",
  streaming: false,
  tags: ["teams"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags teams
 * @name RemoveTeamFromOrganizationById
 * @summary Delete a team
 * @request DELETE:/orgs/{organizationId}/teams/{teamId}
 * @secure
 */

// @ts-ignore
export const removeTeamFromOrganizationById: {
  route: string;
  method: "delete";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique ID of the Team */
    teamId: EntityId;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/orgs/{organizationId}/teams/{teamId}",
  method: "delete",
  streaming: false,
  tags: ["teams"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};
